import GeneralSettings from '@/settings';
export const SHOW_ANNOUNS_BLOCK = (state) => {
  state.showAnnouns = true;
}

export const HIDE_ANNOUNS_BLOCK = (state) => {
  state.showAnnouns = false;
}

export const SHOW_NOTIFS_BLOCK = (state) => {
  state.showNotifs = true;
}

export const HIDE_NOTIFS_BLOCK = (state) => {
  state.showNotifs = false;
}

export const SHOW_REMS_BLOCK = (state) => {
  state.showRems = true;
}

export const HIDE_REMS_BLOCK = (state) => {
  state.showRems= false;
}

export const SET_COLOR_SCHEME = (state, val) => {
  state.colorScheme = val;
}

export const SET_CLIENT_FEATURES = (state, val) => {
  state.clientFeatures = val;
}

export const SET_PROVIDER_FEATURES = (state, val) => {
  state.providerFeatures = val;
}

export const SET_DOCUMENT_TYPES = (state, val) => {
  const documentsOrder = GeneralSettings.CustomerDocumentsOrders;
  state.document_types = val?.sort((a, b) => {
    return documentsOrder[a.object_type] - documentsOrder[b.object_type];
  });
}

export const UPDATE_DOCUMENT_TYPE = (state, val) => {
  let index = state.document_types.findIndex(item => item.id == val.id);
  if (index !== -1) {
    state.document_types.splice(index, 1, val);
  }
}